import { TSchemaBuilder } from "@pages/ManualDocumentV2/core";
import * as Yup from "yup";
import {
  customerSchema,
  documentInfoSchema,
  itemsSchema,
  taxesSchema,
  totalsSchema,
  uploadSchema,
  vendorSchema,
} from "../../_shared/schemaHelpers";

export const purchaseOrderSchema: TSchemaBuilder = (t) =>
  documentInfoSchema({
    t,
    documentClass: "PurchaseOrder",
    poFieldKey: "documentNumber",
    poErrorKey: "documentNumber_is_required",
    dueDateRequired: false,
    enforceDateOrder: false,
  })
    .concat(customerSchema(t, { optional: ["customerCountry", "currency"] }))
    .concat(
      Yup.object({
        customerCompanyAddress: Yup.string().required(
          t("customerCompanyAddress_is_required"),
        ),
      }),
    )
    .concat(vendorSchema(t, { optional: ["vendorCountry"] }))
    .concat(
      Yup.object({
        currency: Yup.string().required(t("currency_is_required")).nullable(),
      }),
    )
    .concat(itemsSchema(t))
    .concat(taxesSchema(t))
    .concat(totalsSchema(t))
    .concat(uploadSchema()) as Yup.ObjectSchema<any>;
